import React, { useState }  from 'react'
import axios from 'axios'
import { MdKeyboardArrowRight,MdKeyboardArrowDown } from 'react-icons/md'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
export default function BookInterviewSimple() {
    const [date, setDate] = useState('')
    const [time, setTime] = useState('')
    const [msg, setMsg] = useState('')
    const [err, setErr] = useState('')
    const [reservation_data, setReservation_data] = useState([])
    const [schedule, setSchedule] = useState([])
    const [scheduleDisplay,setScheduleDisplay] = useState(false)
    const [slotDisplay,setSlotDisplay] = useState(false)
    function join(date, options, separator) {
      function format(option) {
          let formatter = new Intl.DateTimeFormat('en', option)
          return formatter.format(date)
      }
      return options.map(format).join(separator)
    }
    const today = join(new Date(), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
    const today_plus_3days_timestamp = new Date(`${today.slice(5,7)}/${today.slice(8,10)}/${today.slice(0,4)}`).getTime()+(1000*60*60*24*3)
    const today_plus_3days_format = join(new Date(today_plus_3days_timestamp), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
    const today_plus_33days_timestamp = new Date().getTime()+(1000*60*60*24*32)
    const today_plus_33days_format = join(new Date(today_plus_33days_timestamp), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
    const onClick2CreateScheduleMenu = async()=>{
      setMsg('')
      setErr('')
      setDate('')
      setTime('')
      let mtg_timesheet={}
      for(let i1=3;i1<33;i1++){
        const timestamp = new Date(`${today.slice(5,7)}/${today.slice(8,10)}/${today.slice(0,4)}`).getTime()+(1000*60*60*24*i1)
        const format = join(new Date(timestamp), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
        mtg_timesheet[`${format}`] = [{"10.00-11.00":"F"},{"13.00-14.00":"F"},{"14.00-15.00":"F"}]
      }
      let reservation_data2 = ''
      try {
        const { data: res } = await axios.get(`${APIURL}/basic/interview-mtg1`)
        setReservation_data(res.info)
        reservation_data2 = res.info
      } catch (err) {
        console.log(err)
      }
      for(let i2 = 0; i2<Object.keys(reservation_data2).length;i2++){
        let dataset = [{"10.00-11.00":"F"},{"13.00-14.00":"F"},{"14.00-15.00":"F"}]
        for(let i3 = 0; i3<Object.values(reservation_data2)[i2].length;i3++){
          if(Object.keys(Object.values(reservation_data2)[i2][i3])=="10.00-11.00"){
            dataset[0]={"10.00-11.00":"T"}
          }else if(Object.keys(Object.values(reservation_data2)[i2][i3])=="13.00-14.00"){
            dataset[1]={"13.00-14.00":"T"}
          }else{
            dataset[2]={"14.00-15.00":"T"}
          }
        }
        mtg_timesheet[Object.keys(reservation_data2)[i2]]=dataset
      }
      setSchedule(mtg_timesheet)
      setScheduleDisplay(true)
    }
    const onChange2Date = (e) => { 
      setDate(e.target.value)
    } 
    const onClick2CloseBookInterview = async()=>{
      setErr('')
      setMsg('')
      setScheduleDisplay(false)
    }
    const onClick2Submit = async()=>{
      setErr('')
      setMsg('')
      const date_timestamp = new Date(`${date.slice(5,7)}/${date.slice(8,10)}/${date.slice(0,4)}`).getTime()
      if(date==''){
        setErr('Please input reservation date.')
      }else if(time==''){
        setErr('Please select reservation time.')
      }else if(date_timestamp<today_plus_3days_timestamp){
        setErr(`You can book from ${new Date(today_plus_3days_timestamp).toLocaleDateString("en-US", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'})}.`)
      }else{
        const a1 = Object.keys(reservation_data).filter(x=>x==date)
        if(a1.length==1){
          let format = schedule[`${date}`]
          let a2 = {}
          a2[`${time}`]="T"
          format[format.findIndex((x) => Object.keys(x) == time)]=a2
          reservation_data[`${date}`]=format.filter((x)=>Object.values(x)!="F")
        }else{
          let a1 = []
          let a2 ={}
          a2[`${time}`] = "T"
          a1.push(a2)
          reservation_data[`${date}`]=a1
        }
        function timeConverter(x){
          return new Date(`${x.slice(5,7)}/${x.slice(8,10)}/${x.slice(0,4)}`).getTime()
        }
        const reservation_data2 = Object.fromEntries(Object.entries(reservation_data).sort((a, b) => {
          return timeConverter(a[0]) - timeConverter(b[0])
        }))
        try {
          const { data: res } = await axios.post(`${APIURL}/basic/interview-mtg1`,{'reservation_data':reservation_data2})
        } catch (err) {
          console.log(err)
        }
        console.log(reservation_data2)
        setMsg(`You are successfully submitted. Your interview is on ${new Date(date_timestamp).toLocaleDateString("en-US", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} at ${time.toString().slice(0,5)}.`)
        setScheduleDisplay(false)
      }
    }
    return (
      <div>
      <div className='text-xs flex flex-col'>
      <button className='primary-btn w-fit mb-1' onClick={onClick2CreateScheduleMenu} disabled={scheduleDisplay}>Set interview time</button>
      {scheduleDisplay?<><label>Select meeting time</label>
      <div className='flex'>
      <input type='date' name='reservation_date' value={date} 
      min={today_plus_3days_format} max={today_plus_33days_format}
      onChange={(x)=>onChange2Date(x)} 
      className={`${err!=''?'border-red-600':'border-gray-900'} border w-fit mr-1`}/>
      </div>
      {date!=''?<>{schedule[date].map(x2=>Object.values(x2)).join('').includes('F')?'':<span className='text-xs text-red-700'>All booked for this day. Try another date.</span>}
      {err!='' ? <span className='text-xs text-red-700'>{err}</span>:''} 
      {schedule[date].map(x2=><>{Object.values(x2)!='T'?<div className='mt-1 mb-1'><input type='radio' id={Object.keys(x2)} name={date} value='T' onChange={()=>setTime(Object.keys(x2)[0])}/> {Object.keys(x2)}<br/></div>:''}</>)}</>:''}
      <div className='cursor-default flex text-[8px]' onClick={(()=> setSlotDisplay(!slotDisplay))}>See all available time {slotDisplay?<MdKeyboardArrowDown className='mt-auto mb-auto'/>:<MdKeyboardArrowRight className='mt-auto mb-auto' />}</div>
      {slotDisplay?<>{Object.keys(schedule).map(x=><div className='flex'><span className='w-[100px]'>{x}</span> {schedule[x].map(x2=><>{Object.values(x2)!='T'?<span className='w-[80px]'>
      {Object.keys(x2)}</span>:''}</>)}<br/></div>)}</>:''}
      <div className='flex mb-4'><button className='primary-btn text-xs w-fit mt-1 mr-1' onClick={onClick2CloseBookInterview}>Cancel</button><button className='primary-btn text-xs w-fit mt-1' onClick={onClick2Submit}>Submit</button></div>
       </>:''}
      </div>
      {msg!='' ? <>
      <span className='text-xs'>{msg}</span><br/>
      </>:''}
      </div>
    )
  }